import { LiveContainer } from '@/js/live/LiveContainer';
import CoeoFooter from '@/js/shared/components/ui/CoeoFooter';
import React, { FC, useMemo, useCallback } from 'react';
import { useTheme, Theme } from '@mui/material/styles';

interface SiteContainerProps {
  userLoggedIn: boolean;
  path: string;
  children: React.ReactNode;
}

const useStyles = (theme: Theme) =>
  useMemo(
    () => ({
      root: {
        display: 'flex' as const,
        flex: '1 0 100%',
        flexDirection: 'column' as const,
        minHeight: '100vh',
        overflowX: 'hidden' as const,
        backgroundColor: theme.palette.background?.default || '#ffffff',
      },
      content: {
        marginBottom: 'auto',
      },
    }),
    [theme]
  );

export const SiteContainer: FC<SiteContainerProps> = ({
  userLoggedIn,
  path,
  children,
}) => {
  const theme = useTheme();

  if (!theme) {
    console.error('Theme not available in SiteContainer');
    return <div>Loading...</div>;
  }

  const classes = useStyles(theme);

  const PageContent = useCallback(
    () => (
      <main style={classes.root} role="main" aria-label="Site content">
        <div style={classes.content}>{children}</div>
        <CoeoFooter />
      </main>
    ),
    [classes, children]
  );

  const isActive = useCallback((to: string) => to === path, [path]);

  return (
    <LiveContainer isActive={isActive}>
      <PageContent />
    </LiveContainer>
  );
};
